
import { combineReducers } from 'redux';
import auth from './slices/authSlice'; 
import { uMUsersApi } from './apis/usersManagement/users/uMUsersApiSlice';
import { cMCampaignsApi } from './apis/campaignsManagement/campaigns/cMCampaignsApiSlice';
import { cMTypesApi } from './apis/campaignsManagement/types/cMTypesApiSlice';
import { cMCustomerCampaignApi } from './apis/campaignsManagement/customerCampaign/cMCustomerCampaignApiSlice';
import { customerTicketsApi } from './apis/customersManagement/tickets/customerTicketsApiSlice';
import { cMcustomerApi } from './apis/customersManagement/customers/cMcustomerApiSlice';
import { utilsMCountriesApi } from './apis/utilsManagement/countries/utilsMCountriesApiSlice';
import { cMChannelsApi } from './apis/customersManagement/channels/cMChannelsApiSlice';
import { cMLoaApi } from './apis/campaignsManagement/loa/cMLoaApiSlice';
import { cMcustomerServicesApi } from './apis/customersManagement/services/cMcustomerServicesApiSlice';
import { sMServicesApi } from './apis/servicesManagement/sMServicesApiSlice';
import { cMKeywordsApi } from './apis/campaignsManagement/keywords/cMKeywordsApiSlice';
import { uMLanguagesApi } from './apis/utilsManagement/languages/uMLanguagesApiSlice';
import { cMAdvancedKeywordsApi } from './apis/campaignsManagement/advancedKeywords/cMAdvancedKeywordsApiSlice';
import { dMDomainsApi } from './apis/domainsManagement/domains/dMDomainsApiSlice';
import { dMDomainsCategoryApi } from './apis/domainsManagement/category/dMDomainsCategoryApiSlice';
import { dMDomainsIgnoreApi } from './apis/domainsManagement/ignore/dMDomainsIgnoreApiSlice';
import { dMVrdMessagesApi } from './apis/domainsManagement/vrdMessages/dMVrdMessagesApiSlice';
import { lMSearchEngineApi } from './apis/linkManagement/searchEngine/lMSearchEngineApiSlice';
import { lMTubeApi } from './apis/linkManagement/tube/lMTubeApiSlice';
import { lMTelegramApi } from './apis/linkManagement/telegram/lMTelegramApiSlice';
import { lMChangeGetLinkApi } from './apis/linkManagement/changeGetLink/lMChangeGetLinkApiSlice';
import { sMServicesCategoriesApi } from './apis/servicesManagement/sMServicesCategoriesApiSlice';
import { dMIpAddressApi } from './apis/domainsManagement/ipAddress/dMIpAddressApiSlice';
import { dMIspApi } from './apis/domainsManagement/isp/dMIspApiSlice';
import { lmAppsStoresApi } from './apis/linkManagement/app/stores/lmAppsStoresApiSlice';
import { lmAppsDataApi } from './apis/linkManagement/app/data/lmAppsDataApiSlice';
import {lmAppsNameApi } from './apis/linkManagement/apps/lmAppsApiSlice'
import { lmAppsStatusApi } from './apis/linkManagement/app/status/lmAppsStatusApiSlice';
import { lmIptvApi } from './apis/linkManagement/iptv/index/lmIptvApiSlice';
import { lmIptvStatusApi } from './apis/linkManagement/iptv/status/lmIptvStatusApiSlice';
import { lmIptvServerApi } from './apis/linkManagement/iptv/server/lmIptvServerApiSlice';
import { lmIptvTypeApi } from './apis/linkManagement/iptv/type/lmIptvTypeApiSlice';
import { lmIptvReportsApi } from './apis/linkManagement/iptv/reports/lmIptvReportsApiSlice';
import { lmM3uKeywordsApi } from './apis/linkManagement/m3u/lmM3uKeywordsApiSlice';
import { lmM3uResponseMessagesApi } from './apis/linkManagement/m3u/lmM3uResponseMessagesApiSlice';
import { dMDomainsXpathApi } from './apis/domainsManagement/xpath/dMDomainsXpathApiSlice';
import { lMUgcSearchApi } from './apis/linkManagement/ugc/lMUgcSearchApiSlice';
import { lMUgcSeasonApi } from './apis/linkManagement/ugc/lMUgcSeasonApiSlice';
import { lMUgcEpisodeApi } from './apis/linkManagement/ugc/lMUgcEpisodeApiSlice';
import { lMUgcSourceApi } from './apis/linkManagement/ugc/lMUgcSourceApiSlice';
import { lmNewM3uApi } from './apis/linkManagement/m3u/lmNewM3uApiSlice';
import { lMTubeChannelsApi } from './apis/linkManagement/tube/lMTubeChannelsApiSlice';
import { dMDomainsTubeWhitelistApi } from './apis/domainsManagement/domains/dMDomainsTubeWhitelistApiSlice';
import { reportsApiSlice } from './apis/reports/reportsApiSlice';
import { bDDomainsApi } from './apis/blockingDomainsManagement/bDDomainsApiSlice';
import { bDCategoriesApi } from './apis/blockingDomainsManagement/bDCategoriesApiSlice';
import { bDActivitiesApi } from './apis/blockingDomainsManagement/bDActivitiesApiSlice';
import { lmM3uFilesApi } from './apis/linkManagement/m3u/lmM3uFilesApiSlice';
import { uMOpsApi } from './apis/usersManagement/users/uMOpsApiSlice';
import { aMOpsApi } from './apis/analyticsManagement/aMOpsApiSlice';
import { aMAnalyticsApi } from './apis/analyticsManagement/aMAnalyticsApiSlice';
import { aMIptvAnalyticsApi } from './apis/analyticsManagement/aMIptvAnalyticsApiSlice';
import { aMLiveStreamingStatsApi } from './apis/analyticsManagement/aMLiveStreamingStatsApiSlice';
import { tMDistriputionApi } from './apis/taskManagement/tMDistriputionApiSlice';
import { uMUserWeightsApi } from './apis/usersManagement/users/uMUserWeightsApiSlice';
import { lmIptvFilesApi } from './apis/linkManagement/iptv/media/lmIptvFilesApiSlice';
import { uMGuacamoleApi } from './apis/utilsManagement/guacamole/uMGuacamoleApiSlice';
import { GuacamoleApi } from './apis/GuacamoleManagment/GuacamoleApiSlice';
import { uMCollectorScheduleApi } from './apis/utilsManagement/collectorSchedule/uMCollectorScheduleApiSlice';

export default combineReducers({
  auth, 
  [uMUsersApi.reducerPath]: uMUsersApi.reducer,
  [utilsMCountriesApi.reducerPath]: utilsMCountriesApi.reducer,
  [customerTicketsApi.reducerPath]: customerTicketsApi.reducer,
  [cMCampaignsApi.reducerPath]: cMCampaignsApi.reducer,
  [cMTypesApi.reducerPath]: cMTypesApi.reducer,
  [cMCustomerCampaignApi.reducerPath]: cMCustomerCampaignApi.reducer,
  [cMcustomerApi.reducerPath]: cMcustomerApi.reducer,
  [cMChannelsApi.reducerPath]: cMChannelsApi.reducer,
  [cMLoaApi.reducerPath]: cMLoaApi.reducer,
  [cMcustomerServicesApi.reducerPath]: cMcustomerServicesApi.reducer,
  [sMServicesApi.reducerPath]: sMServicesApi.reducer,
  [cMKeywordsApi.reducerPath]: cMKeywordsApi.reducer,
  [uMLanguagesApi.reducerPath]: uMLanguagesApi.reducer,
  [cMAdvancedKeywordsApi.reducerPath]: cMAdvancedKeywordsApi.reducer,
  [dMDomainsApi.reducerPath]: dMDomainsApi.reducer,
  [dMDomainsCategoryApi.reducerPath]: dMDomainsCategoryApi.reducer,
  [dMDomainsIgnoreApi.reducerPath]: dMDomainsIgnoreApi.reducer,
  [dMVrdMessagesApi.reducerPath]: dMVrdMessagesApi.reducer,
  [lMSearchEngineApi.reducerPath]: lMSearchEngineApi.reducer,
  [lMTubeApi.reducerPath]: lMTubeApi.reducer,
  [lMTelegramApi.reducerPath]: lMTelegramApi.reducer,
  [lMChangeGetLinkApi.reducerPath]: lMChangeGetLinkApi.reducer,
  [sMServicesCategoriesApi.reducerPath]: sMServicesCategoriesApi.reducer,
  [dMIpAddressApi.reducerPath]: dMIpAddressApi.reducer,
  [dMIspApi.reducerPath]: dMIspApi.reducer,
  [lmAppsStoresApi.reducerPath]: lmAppsStoresApi.reducer,
  [lmAppsNameApi.reducerPath]: lmAppsNameApi.reducer,
  [lmAppsDataApi.reducerPath]: lmAppsDataApi.reducer,
  [lmAppsStatusApi.reducerPath]: lmAppsStatusApi.reducer,
  [lmIptvApi.reducerPath]: lmIptvApi.reducer,
  [lmIptvStatusApi.reducerPath]: lmIptvStatusApi.reducer,
  [lmIptvServerApi.reducerPath]: lmIptvServerApi.reducer,
  [lmIptvTypeApi.reducerPath]: lmIptvTypeApi.reducer,
  [lmIptvReportsApi.reducerPath]: lmIptvReportsApi.reducer,
  [lmM3uKeywordsApi.reducerPath]: lmM3uKeywordsApi.reducer,
  [lmM3uResponseMessagesApi.reducerPath]: lmM3uResponseMessagesApi.reducer,
  [dMDomainsXpathApi.reducerPath]: dMDomainsXpathApi.reducer,
  [lMUgcSearchApi.reducerPath]: lMUgcSearchApi.reducer,
  [lMUgcSeasonApi.reducerPath]: lMUgcSeasonApi.reducer,
  [lMUgcEpisodeApi.reducerPath]: lMUgcEpisodeApi.reducer,
  [lMUgcSourceApi.reducerPath]: lMUgcSourceApi.reducer,
  [lmNewM3uApi.reducerPath]: lmNewM3uApi.reducer,
  [lMTubeChannelsApi.reducerPath]: lMTubeChannelsApi.reducer,
  [dMDomainsTubeWhitelistApi.reducerPath]: dMDomainsTubeWhitelistApi.reducer,
  [reportsApiSlice.reducerPath]: reportsApiSlice.reducer,
  [bDDomainsApi.reducerPath]: bDDomainsApi.reducer,
  [bDCategoriesApi.reducerPath]: bDCategoriesApi.reducer,
  [bDActivitiesApi.reducerPath]: bDActivitiesApi.reducer,
  [lmM3uFilesApi.reducerPath]: lmM3uFilesApi.reducer,
  [uMOpsApi.reducerPath]: uMOpsApi.reducer,
  [aMOpsApi.reducerPath]: aMOpsApi.reducer,
  [aMAnalyticsApi.reducerPath]: aMAnalyticsApi.reducer,
  [aMIptvAnalyticsApi.reducerPath]: aMIptvAnalyticsApi.reducer,
  [aMLiveStreamingStatsApi.reducerPath]: aMLiveStreamingStatsApi.reducer,
  [tMDistriputionApi.reducerPath]: tMDistriputionApi.reducer,
  [uMUserWeightsApi.reducerPath]: uMUserWeightsApi.reducer,
  [lmIptvFilesApi.reducerPath]: lmIptvFilesApi.reducer,
  [uMGuacamoleApi.reducerPath]: uMGuacamoleApi.reducer,
  [GuacamoleApi.reducerPath]: GuacamoleApi.reducer,
  [uMCollectorScheduleApi.reducerPath]: uMCollectorScheduleApi.reducer,
});